import { render, staticRenderFns } from "./Facilities.vue?vue&type=template&id=0ffd02aa&scoped=true"
import script from "./Facilities.vue?vue&type=script&lang=js"
export * from "./Facilities.vue?vue&type=script&lang=js"
import style0 from "./Facilities.vue?vue&type=style&index=0&id=0ffd02aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffd02aa",
  null
  
)

export default component.exports